import { useCRUD } from './useCRUD';
import type { FieldTemplate, CreateFieldTemplateDto } from '@/types/form';

/**
 * Hook pour gérer les templates de champs de formulaire
 */
export function useFieldTemplates() {
  const fieldTemplatesCRUD = useCRUD<FieldTemplate, CreateFieldTemplateDto>('field_templates', {
    select: '*',
    orderBy: { column: 'category', ascending: true },
  });

  // Grouper les templates par catégorie
  const templatesByCategory = (fieldTemplatesCRUD.data || []).reduce(
    (acc: Record<string, FieldTemplate[]>, template: FieldTemplate) => {
      const category = template.category || 'default';
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(template);
      return acc;
    },
    {} as Record<string, FieldTemplate[]>
  );

  return {
    templates: fieldTemplatesCRUD.data || [],
    isLoading: fieldTemplatesCRUD.loading,
    error: fieldTemplatesCRUD.error,
    refetch: fieldTemplatesCRUD.refresh,
    createTemplate: fieldTemplatesCRUD.create,
    templatesByCategory,
  };
}
